import { render, staticRenderFns } from "./InvoiceUploadSuccess.vue?vue&type=template&id=59553fe1"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports